export const email = 'hallo@bonitaetsmanager.de'
export const phone = '06196 99 3699'
